import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";
import LinkIcon from '@material-ui/icons/Link';

import accounts from "../../accounts";
import transactions from "../../transactions";

// Promoter Menu
export const PromoterSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'promoter'
                ? <>
                    <MenuItemLink
                        to={`/accounts`}
                        primaryText={translate(`resources.accounts.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<accounts.icon />}
                        onClick={onMenuClick}
                     />
                    <MenuItemLink
                        to={`/transactions`}
                        primaryText={translate(`resources.transactions.name`, {
                            smart_count: 2
                        })}
                        leftIcon={<transactions.icon/>}
                        onClick={onMenuClick}
                    />
                    <MenuItemLink
                        to={`/invitation-link`}
                        primaryText="Invitation Link"
                        leftIcon={<LinkIcon/>}
                        onClick={onMenuClick}
                    />
                </>
                : null
        )}
    >
    </WithPermissions>
)